import React from "react";
import { useRouteMatch } from "react-router";
import AppBar from "../../../Components/AppBar";
import MobilePage from "../../../../Components/MobilePage";
import CardWrapper from "./CardWrapper";
import { CalendarWrapper } from "./CalendarWrapper";
import { PhotogiftWrapper } from "./PhotogiftWrapper";

export default () => {
  const routeMatch = useRouteMatch();
  const { type, category } = routeMatch.params;

  return (
    <MobilePage>
      <AppBar />
      {type == "cards" && <CardWrapper type={type} category={category} />}
      {type == "calendars" && (
        <CalendarWrapper type={type} category={category} />
      )}
      {type == "photogifts" && (
        <PhotogiftWrapper type={type} category={category} />
      )}
    </MobilePage>
  );
};
